import { SxProps, Theme } from '@mui/material';

import TextField from 'domains/core/components/TextField';
import { SegmentDemographicValue } from 'domains/segments/types';
import { SQLType } from 'models/enums';

import { getInputType } from '../../utils';

type Props = {
    error?: boolean;
    helperText?: string;
    onChange: (value: any) => void;
    placeholderName: string;
    sqlType: SQLType;
    sx?: SxProps<Theme>;
    value: SegmentDemographicValue;
};

const TextFieldInput = ({ error, helperText, onChange, placeholderName, sqlType, sx, value }: Props) => (
    <TextField
        data-testid="valueTextField"
        error={error}
        helperText={helperText}
        label="Value"
        onChange={(e) => onChange(e.target.value)}
        placeholder={`Enter a value for ${placeholderName}`}
        sx={{
            width: '16rem',
            ...sx,
        }}
        type={getInputType(sqlType)}
        value={value}
    />
);

export default TextFieldInput;
